export default __webpack_public_path__ + "static/media/Ragavan.ddff568e.png";